// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counts_dzTyL {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 6px;
}

.separator_hibER {
  border-left: 1px solid #00000020;
  height: 26px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/renderers/OccupancyCountsAttributeRenderer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd","sourcesContent":[".counts {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.separator {\n  border-left: 1px solid #00000020;\n  height: 26px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"counts": `counts_dzTyL`,
	"separator": `separator_hibER`
};
export default ___CSS_LOADER_EXPORT___;
